import { render } from "./allocateprojectusers.vue?vue&type=template&id=418f506e&scoped=true"
import script from "./allocateprojectusers.vue?vue&type=script&lang=js"
export * from "./allocateprojectusers.vue?vue&type=script&lang=js"

import "./allocateprojectusers.vue?vue&type=style&index=0&id=418f506e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418f506e"]])

export default __exports__